<template>
  <!-- 购物车页面 -->
  <div class="content">
    <div class="header">
      <van-nav-bar
        title="购物车"
        left-arrow
        right-text="清除"
        :fixed="true"
        :placeholder="true"
        @click-left="$router.back()"
        @click-right="onClickRight"
      />
    </div>
    <div class="center">
      <van-checkbox-group
        ref="checkboxGroup"
        @change="handleCheckedCitiesChange"
        v-model="checked"
      >
        <div
          class="checkboxGroupTop"
          v-for="(item, index) in checkedss"
          :key="index"
        >
          <van-checkbox
            :name="item"
            label-disabled
            :class="
              item.onsell_num == 0 || item.status == 0 ? { orderList: true } : 0
            "
          >
            <van-card
              :desc="item.color_name"
              :title="item.product_name"
              :thumb="item.color_img"
            >
              <template #tags>
                <van-tag plain type="danger">
                  <span>¥{{ Number(item.price).toFixed(2) }}</span>
                  <van-stepper
                    theme="round"
                    v-model="item.goods_num"
                    :integer="true"
                    :name="item.record_id"
                    @change="onChange(item)"
                    min="1"
                    :max="item.stock > 99 ? 99 : item.stock"
                  />
                </van-tag>
              </template>
            </van-card>
          </van-checkbox>
        </div>
        <div class="efficacyTop">
          <p
            class="shiText"
            v-if="efficacy.length > 0"
            style="margin:0 0.373333rem"
          >
            <span>已失效{{ efficacy.length }}件</span
            ><span @click="getEliminate()">清空失效商品</span>
          </p>
          <div class="efficacy" v-for="list in efficacy" :key="list.record_id">
            <img
              class="biao"
              src="../../assets/img/icon/组 9774@2x.png"
              alt=""
            />
            <div class="conent">
              <img :src="list.color_img" alt="" />
              <div class="text">
                <p class="p1">{{ list.product_name }}</p>
                <p class="p2">{{ list.color_name }}</p>
                <p class="p3"><span>失效</span> ￥{{ list.price }}</p>
              </div>
            </div>
            <van-button
              class="btn"
              color="#999999"
              round
              plain
              size="small"
              type="primary"
              @click="$router.push('/index')"
              >查看其他商品</van-button
            >
          </div>
        </div>
      </van-checkbox-group>
      <div class="emptyCar" v-if="carNum == 0">
        <img src="../../assets/img/组 7414@2x.png" alt="" />
      </div>
    </div>
    <!-- 全选结算栏 -->
    <van-submit-bar
      safe-area-inset-bottom
      :price="totalPrice"
      button-text="去结算"
      @submit="onSubmit"
      v-show="this.checkedss.length == 0 ? false : true"
    >
      <van-checkbox
        v-show="this.checkedss.length == 0 ? false : true"
        v-model="checke"
        @change="checkeds"
        >全选</van-checkbox
      >
    </van-submit-bar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isTrue: "orderList",
      checked: [],
      checkedss: [],
      checke: false,
      cartList: {},
      carNum: "",
      newCartList: [],
      startTime: Date.now(), //开始时间
      time: 1500, //间隔时间
      timer: "",
      cartValue: "",
      cartDetailId: "",
      flag: true,
      totalPrice: 0,
      efficacy: [], //失效商品列表
      efficacyId: [], //失效商品id
    };
  },
  created() {
    this.getShoppingCart();
  },
  watch: {
    checked: {
      handler(newVal, oldVal) {
        let price = 0;
        this.checked.forEach((item) => {
          price += Number(item.price * item.goods_num) * 100;
        });
        this.totalPrice = price;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 去结算
    async onSubmit() {
      await this.$post({
        url: "/osc/findOmsShoppingCartAll",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            if (this.totalPrice !== 0) {
              this.newCartList = res.data.code;
              let newArrId = this.checked.map((item) => {
                return this.newCartList.filter((element) => {
                  return element.record_id == item.record_id;
                });
              });
              newArrId = [].concat(...newArrId);
              this.checke = true;
              this.$store.commit("toAccounts", newArrId);
              this.$router.push("/onfirmOrder");
              sessionStorage.setItem("PRODUCT_LIST", JSON.stringify(newArrId));
              if (this.$route.path == "/onfirmOrder") {
                this.$router.go(0);
              } else {
                return false;
              }
            } else {
              this.$toast("至少选择一件商品");
            }
          }
        })
        .catch((err) => {
          this.$toast("加载失败");
        });
    },
    // 全选按钮切换
    async checkeds(val) {
      if (val) {
        this.checked = this.checkedss;
      } else {
        if (this.checked.length == this.checkedss.length) {
          this.checked = [];
        }
      }
    },
    // 全部选择切换全选效果
    async handleCheckedCitiesChange(value) {
      if (value.length == this.checkedss.length && this.checkedss.length != 0) {
        this.checke = true;
      } else {
        this.checke = false;
      }
    },
    // 获取购物车里的商品
    async getShoppingCart() {
      await this.$post({
        url: "/osc/findOmsShoppingCartAll",
        method: "post",
        params: {
          userId: sessionStorage.getItem("EXCLUSIVE"),
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.cartList = res.data.code;
            this.carNum = res.data.code.length;
            this.cartList.map((item) => {
              if (item.onsell_num == 0 || item.status == 0||item.sku_status==0) {
                return this.efficacy.push(item);
              }
            });
            this.cartList.map((item) => {
              if (item.onsell_num !== 0) {
                if (item.status !== 0&&item.sku_status!==0) {
                  return this.checkedss.push(item);
                }
              }
            });
          }
        })
        .catch((err) => {
          this.$toast("加载失败");
        });
    },
    // 商品数量修改
    onChange(item) {
      this.$post({
        url: "/osc/updOmsShoppingCartNum",
        method: "post",
        params: {
          recordId: item.record_id,
          goodsNum: item.goods_num,
          skuId: item.sku_id,
        },
      })
        .then((res) => {
          if (res.retCode == 500102) {
            this.$toast(res.message);
          }
        })
        .catch((err) => {
          this.$toast("修改失败");
        });
    },
    // 清除购物车
    onClickRight() {
      if (this.checked.length !== 0) {
        let recordIds = [];
        this.checked.map((item) => {
          return recordIds.push(item.record_id + "");
        });
        this.$dialog
          .confirm({
            title: "清除",
            confirmButtonText: "确定",
            message: "您确定要清除该商品吗？",
          })
          .then(async () => {
            const res = await this.$post({
              url: "/osc/delOmsShoppingCart",
              method: "post",
              params: {
                recordId: recordIds.join(","),
              },
            });
            if (res.retCode == 200) {
              // 全选等于空
              this.checkedss = [];
              this.checked = [];
              this.efficacy=[];
              // 刷新页面
              // 获取购物车数据
              this.getShoppingCart();
              if (this.checkedss.length == 0) {
                this.checke = false;
                this.$toast("清除成功");
                this.$router.go(0);
              }
            } else {
              this.$toast("操作失败");
            }
          })
          .catch(() => {});
      } else {
        this.$toast("请选择商品");
      }
    },
    // 清除失效商品
    async getEliminate() {
      this.efficacy.map((item) => {
        return this.efficacyId.push(item.record_id + "");
      });
      await this.$post({
        url: "/osc/delOmsShoppingCart",
        method: "post",
        params: {
          recordId: this.efficacyId.join(","),
        },
      }).then((res) => {
        if (res.retCode == 200) {
          this.efficacy = [];
          this.getShoppingCart();
          this.$router.go(0);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  min-height: 100%;
  position: relative;
  background-color: #e8e8e8;
  .header {
    /deep/.van-icon-arrow-left::before {
      font-size: 0.533333rem;
      color: black;
    }
    /deep/.van-nav-bar__title {
      font-weight: 600;
    }
    /deep/.van-nav-bar__text {
      color: black;
    }
  }
  .center {
    margin-top: 0.266667rem;
    background-color: #1f000000;
    padding-bottom: 1.3rem;
    position: relative;
    .checkboxGroupTop {
      margin: 0 0.373333rem;
    }
    .van-checkbox {
      background-color: #ffffff;
      border-radius: 0.21rem;
      margin-bottom: 0.27rem;
      /deep/.van-checkbox__icon.van-checkbox__icon--round {
        margin-left: 0.27rem;
      }
      /deep/.van-checkbox__icon--checked .van-icon {
        color: #fff;
        background-color: #f74b2e;
        border-color: #f74b2e;
      }
    }
    .van-card {
      width: 8rem;
      height: 3rem;
      margin-top: 0.3rem;
      padding: 0.21333rem 0.12667rem;
      float: right;
      background-color: #ffffff;
      border-radius: 8%;
      .van-card__content {
        .van-card__title.van-multi-ellipsis--l2 {
          font-size: 0.3733rem;
          font-weight: 500;
          margin-top: 0.4rem;
          color: #333333;
        }
        .van-card__desc.van-ellipsis {
          font-size: 0.32rem;
          margin-top: 0.16rem;
        }
        .van-tag.van-tag--plain.van-tag--default.van-hairline--surround {
          font-size: 0rem;
        }
        .van-tag.van-tag--plain.van-tag--danger {
          display: block;
          width: 5.5rem;
          padding: 0 !important;
          span {
            float: left;
            margin-top: 0.19rem;
            font-size: 0.37rem;
            font-weight: 500;
            font-family: PingFang SC;
            color: #f74b2e;
          }
          .van-stepper {
            float: right !important;
            margin-right: 0.3rem;
            /deep/button {
              width: 0.53rem;
              height: 0.53rem;
              border-color: #999999;
              background-color: #fff;
            }
            /deep/.van-stepper__minus {
              color: #323233 !important;
            }
            /deep/.van-stepper__plus {
              color: #323233;
              border: 1px solid #999999;
            }
          }
        }
      }
      .van-card__thumb {
        margin-right: 0.31rem;
      }
      .van-tag {
        color: #ffffff;
      }
    }
    .emptyCar {
      img {
        margin: 3rem auto 0;

        display: block;
        height: 5rem;
        width: 5.6rem;
      }
    }
    .efficacyTop {
      // margin-top: 30px;
      .shiText {
        margin-top: 0.373333rem;
        display: flex;
        justify-content: space-between;
        font-size: 0.32rem;
        color: #666666;
      }
      .efficacy {
        margin: 0.373333rem;
        display: flex;
        align-items: center;
        background-color: #ffffff;
        .biao {
          width: 0.533333rem;
          height: 0.533333rem;
          margin-left: 0.273333rem;
          margin-right: 0.133333rem;
        }
        .conent {
          display: flex;
          align-items: center;
          img {
            width: 2.346667rem;
            height: 2.346667rem;
            margin: 0.133333rem 0;
          }
          .text {
            margin-left: 0.266667rem;
            .p1 {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 2.4rem;
              font-size: 0.373333rem;
              color: #999999;
              font-weight: 500;
              font-family: PingFang SC;
            }
            .p2 {
              font-size: 0.32rem;
              font-weight: 400;
              font-family: PingFang SC;
              color: #999999;
              margin: 0.133333rem 0 0.266667rem 0;
            }
            .p3 {
              display: flex;
              align-items: center;
              text-align: center;
              color: #999999;
              font-size: 0.373333rem;
              span {
                display: block;
                width: 1.066667rem;
                height: 0.533333rem;
                border-radius: 0.533333rem;
                padding: 0 0.106667rem;
                color: #ffffff;
                background-color: #999999;
              }
            }
          }
        }
        .btn {
          margin-left: 0.626667rem;
        }
      }
    }
  }
  .van-submit-bar {
    /deep/.van-checkbox__icon--checked .van-icon {
      color: #fff;
      background-color: #f74b2e;
      border-color: #f74b2e;
    }
  }
}
</style>
